import React, { createContext, useContext, useMemo, useState } from 'react';

type ConnectorSelectionType = {
  connectorsSelectionStatus: string;
  setConnectorsSelectionStatus: React.Dispatch<React.SetStateAction<string>>;
};

export const ConnectorSelectionContext = createContext<ConnectorSelectionType | null>(
  null
);

export const useConnectorSelectionContext = (): ConnectorSelectionType => {
  const val = useContext(ConnectorSelectionContext);
  if (!val) {
    throw new Error(
      'useConnectorSelectionContext must be called within a ConnectorSelectionContextProvider'
    );
  }
  return val;
};

const ConnectorSelectionContextProvider: React.FC = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  const [connectorsSelectionStatus, setConnectorsSelectionStatus] = useState(
    'connectors.all'
  );

  const value = useMemo(() => {
    return {
      connectorsSelectionStatus: connectorsSelectionStatus,
      setConnectorsSelectionStatus: setConnectorsSelectionStatus
    };
  }, [connectorsSelectionStatus]);

  return (
    <ConnectorSelectionContext.Provider value={value}>
      {children}
    </ConnectorSelectionContext.Provider>
  );
};

export default ConnectorSelectionContextProvider;
